import { useTranslation } from 'react-i18next';
import { Button, DialogActions } from '@mui/material';
import PropTypes from 'prop-types';

import Modal from 'src/components/common/Modal';

const DeleteConfirmationModal = ({
  actionPlanName,
  showModal,
  onClose,
  handleDelete,
}) => {
  const { t } = useTranslation(['planAction', 'common']);

  return (
    <Modal
      headline={t('planAction:ActionPlan.DeleteModalHeadline', {
        actionPlanName,
      })}
      message={t('planAction:ActionPlan.DeleteWarning')}
      isOpen={showModal}
      onClose={onClose}
    >
      <DialogActions>
        <Button variant="cta" color="secondary" fullWidth onClick={onClose}>
          {t('common:cancel')}
        </Button>

        <Button variant="cta" fullWidth onClick={handleDelete}>
          {t('common:confirm')}
        </Button>
      </DialogActions>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  actionPlanName: PropTypes.string.isRequired,
  handleDelete: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};

export default DeleteConfirmationModal;
